import { TableHeaderNamesConstants } from '../../ui/constants/table-header-names.constants';

export class TableSortDetails {
  tableIdentifier: string;
  key: TableHeaderNamesConstants;
  orderBy: SortingOrder
}

export enum TableType {
  SWITCHBOARD_BOM = 'SWITCHBOARD_BOM',
  ACCESSORIES_BOM = 'ACCESSORIES_BOM',
  SWITCHBOARD_PROJECT_BOM = 'SWITCHBOARD_PROJECT_BOM',
  ACCESSORIES_PROJECT_BOM = 'ACCESSORIES_PROJECT_BOM',
  COMPONENTS_PROJECT_BOM = 'COMPONENTS_PROJECT_BOM',
  PROJECTS_LIST = 'PROJECTS_LIST',
  ACCEPTED_SHARED_PROJECTS = 'ACCEPTED_SHARED_PROJECTS',
  PENDING_SHARED_PROJECTS = 'PENDING_SHARED_PROJECTS',
  ASSIGNED_COMPANY_PROJECTS = 'ASSIGNED_COMPANY_PROJECTS',
  UNASSIGNED_COMPANY_PROJECTS = 'UNASSIGNED_COMPANY_PROJECTS',
  ARCHIVED_PROJECTS_LIST = 'ARCHIVED_PROJECTS_LIST',
}

export enum SortingOrder {
  ASCENDING,
  DESCENDING,
  NONE
}
